import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import './ReviewsSection.css';

class ReviewsSection extends PureComponent {
  render() {
    const { t } = this.props;

    return (
      <div className="section reviews-section">
        <Grid>
          <h2>{t('Reviews from previous customers')}</h2>

          <Row componentClass="ul" className="home-reviews-list">
            <Col componentClass="li" md={4} sm={6} xs={12}>
              <div className="review-item">
                <div className="content">
                  {t('I can say that BikesBooking is reliable and trustworthy. I\'ve rented a Vespa and it was perfect.')}
                  <div className="rating rating-5" />
                </div>
                <span className="author">{t('Paolo')}</span>
                <span className="service-description">
                  {t('rented a scooter')}
                </span>
              </div>
            </Col>
            <Col componentClass="li" md={4} sm={6} xs={12}>
              <div className="review-item">
                <div className="content">
                  {t('Hired a motorcycle with my girlfriend and had an amazing week exploring the island.')}
                  <div className="rating rating-4" />
                </div>
                <span className="author">{t('John')}</span>
                <span className="service-description">
                  {t('rented a motorcycle')}
                </span>
              </div>
            </Col>
            <Col componentClass="li" md={4} mdOffset={0} sm={6} smOffset={3} xs={12} xsOffset={0}>
              <div className="review-item">
                <div className="content">
                  {t('Simply great! Only on this website I found a company with new bikes and delivery to hotel.')}
                  <div className="rating rating-5" />
                </div>
                <span className="author">{t('Ann')}</span>
                <span className="service-description">
                  {t('rented a bike')}
                </span>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default translate(['translation'])(ReviewsSection);



// WEBPACK FOOTER //
// ./src/components/HomePage/ReviewsSection/ReviewsSection.js